// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ObjectImages_object-pictures__shoZ8 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
}
.ObjectImages_object-pictures__shoZ8 > * {
  margin: 5px;
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB {
  width: 20px;
  height: 20px;
  background-color: grey;
  background-position: center;
  background-size: cover;
  transition: all 0.5s ease;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  padding: 5px;
  align-items: flex-end;
  justify-content: space-between;
  cursor: pointer;
  transition-property: width, height, border-radius;
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB:hover {
  width: 150px;
  height: 150px;
  transition-duration: 2s;
  transition-delay: 1s;
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB a,
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB button {
  display: none;
  padding: 5px 10px;
  border: none;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  height: 26px;
  align-items: center;
  justify-content: center;
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB a svg,
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB button svg {
  width: 16px;
  height: 16px;
  fill: white;
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB a:hover svg {
  fill: rgb(120, 255, 120);
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB button:hover svg {
  fill: rgb(255, 120, 120);
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB.ObjectImages_image-opened__cT9o- {
  width: 150px;
  height: 150px;
  border-radius: 10px;
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB.ObjectImages_image-opened__cT9o- a,
.ObjectImages_object-pictures__shoZ8 .ObjectImages_object-picture__4JvcB.ObjectImages_image-opened__cT9o- button {
  display: inline-flex;
  animation: ObjectImages_appear__qyBCx 1s ease;
  position: relative;
}
@keyframes ObjectImages_appear__qyBCx {
  0% {
    top: -100px;
    opacity: 0;
    display: none;
  }
  50% {
    top: 0;
    opacity: 0;
    display: inline-block;
  }
  100% {
    opacity: 1;
  }
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_add-button__fNpQ9 {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 20px;
  height: 20px;
  padding: 4px 0;
  background-color: transparent;
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_add-button__fNpQ9 svg {
  width: 100%;
  height: 100%;
  fill: rgb(140, 140, 140);
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_add-button__fNpQ9:hover {
  background-color: rgb(240, 240, 240);
}
.ObjectImages_object-pictures__shoZ8 .ObjectImages_add-button__fNpQ9:active {
  background-color: rgb(230, 230, 230);
}`, "",{"version":3,"sources":["webpack://./src/Components/ObjectImages/ObjectImages.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AACJ;AACI;EACI,WAAA;AACR;AAEI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,iDAAA;AAAR;AAEQ;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AAAZ;AAGQ;;EAEI,aAAA;EACA,iBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AADZ;AAGY;;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAAhB;AAMgB;EACI,wBAAA;AAJpB;AAWgB;EACI,wBAAA;AATpB;AAcQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAZZ;AAcY;;EAEI,oBAAA;EACA,6CAAA;EACA,kBAAA;AAZhB;AAcgB;EACI;IACI,WAAA;IACA,UAAA;IACA,aAAA;EAZtB;EAekB;IACI,MAAA;IACA,UAAA;IACA,qBAAA;EAbtB;EAgBkB;IACI,UAAA;EAdtB;AACF;AAqBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,6BAAA;AAnBR;AAqBQ;EACI,WAAA;EACA,YAAA;EACA,wBAAA;AAnBZ;AAsBQ;EACI,oCAAA;AApBZ;AAuBQ;EACI,oCAAA;AArBZ","sourcesContent":[".object-pictures {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    >* {\n        margin: 5px;\n    }\n\n    .object-picture {\n        width: 20px;\n        height: 20px;\n        background-color: grey;\n        background-position: center;\n        background-size: cover;\n        transition: all 0.5s ease;\n        border-radius: 4px;\n        display: flex;\n        flex-direction: row;\n        padding: 5px;\n        align-items: flex-end;\n        justify-content: space-between;\n        cursor: pointer;\n        transition-property: width, height, border-radius;\n\n        &:hover {\n            width: 150px;\n            height: 150px;\n            transition-duration: 2s;\n            transition-delay: 1s;\n        } // Allow the user to see the object image getting bigger without clicking on it\n\n        a,\n        button {\n            display: none;\n            padding: 5px 10px;\n            border: none;\n            background-color: rgba(0, 0, 0, 0.7);\n            border-radius: 5px;\n            height: 26px;\n            align-items: center;\n            justify-content: center;\n\n            svg {\n                width: 16px;\n                height: 16px;\n                fill: white;\n            }\n        }\n\n        a {\n            &:hover {\n                svg {\n                    fill: rgb(120, 255, 120);\n                }\n            }\n        }\n\n        button {\n            &:hover {\n                svg {\n                    fill: rgb(255, 120, 120);\n                }\n            }\n        }\n\n        &.image-opened {\n            width: 150px;\n            height: 150px;\n            border-radius: 10px;\n\n            a,\n            button {\n                display: inline-flex;\n                animation: appear 1s ease;\n                position: relative;\n\n                @keyframes appear {\n                    0% {\n                        top: -100px;\n                        opacity: 0;\n                        display: none;\n                    }\n\n                    50% {\n                        top: 0;\n                        opacity: 0;\n                        display: inline-block;\n                    }\n\n                    100% {\n                        opacity: 1;\n                    }\n                }\n            }\n\n        }\n    }\n\n    .add-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        width: 20px;\n        height: 20px;\n        padding: 4px 0;\n        background-color: transparent;\n\n        svg {\n            width: 100%;\n            height: 100%;\n            fill: rgb(140, 140, 140);\n        }\n\n        &:hover {\n            background-color: rgb(240, 240, 240);\n        }\n\n        &:active {\n            background-color: rgb(230, 230, 230);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"object-pictures": `ObjectImages_object-pictures__shoZ8`,
	"object-picture": `ObjectImages_object-picture__4JvcB`,
	"image-opened": `ObjectImages_image-opened__cT9o-`,
	"appear": `ObjectImages_appear__qyBCx`,
	"add-button": `ObjectImages_add-button__fNpQ9`
};
export default ___CSS_LOADER_EXPORT___;
